<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox ref="navChild" :pageName="'Products'"></navBox>
			<!--导航-->
			<!--位置-->
			<div class="location_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<van-icon name="wap-home" class="icon" color="#808080" size="20px" />
				<span @click="goHome" style="cursor: pointer;">Home</span>
				<van-icon name="arrow" class="icon" color="#808080" size="18px" />
				<span style="color: #808080;">Products</span>
			</div>
			<!--位置-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div class="tit"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>Product Introduction</div>
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="200"
						data-aos-offset="0"
						data-aos-once="true"
					>Antibodies & Antigens</div>
					<div class="text"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						For over 20 years UC reagent has provided innovative life science solutions to the diagnostic industry. The company has thousands of antigens and antibodies covering viral and infectious disease, drug of abuse, fertility, hormone, sexually transmitted disease, neurological disorder, digestive tract, respiratory tract, renal disease, bone metabolism, inflammation, diabetes, tumor marker, cardiac marker, tropical disease, vet health, and more. UC reagent’s expertise in pathology, virology, cell culture, protein expression, and protein purification has enabled the company to become a leader in infectious disease, reproductive and drug test in the world. Our portfolio also includes a range of controls, standards, tags, blockings, conjugates and secondary antibodies, etc.
					</div>
					<div class="txt"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="400"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Should you have any specific product or testing service requests, please <span @click="goContact">contact us</span> for ordering or partnership opportunities.
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div id="jumpBox" class="block_2">
				<div class="top_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div>Product Filters</div>
				</div>
				<div class="block_2_main">
					<div class="list_box">
						<div class="list_el"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<!-- <div class="left">Product Type</div> -->
							<div class="right">
								<div v-for="(value, index) in cate_list" :key="index" :class="cateId == value.id ? 'actived' : ''" @click="cateClick(value)">{{ value.title }}</div>
								<div @click="goIm">NC Membrane</div>
							</div>
						</div>
						<div class="list_el"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<!-- <div class="left">Primary Diseases</div> -->
							<div class="right">
								<div v-for="(value, index) in diseases_list" :key="index" :class="diseasesId == value.id ? 'actived' : ''" @click="diseasesClick(value)">{{ value.title }}</div>
							</div>
						</div>
						<div v-if="secondaryList.length > 0" class="list_el"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<!-- <div class="left">Secondary Diseases</div> -->
							<div class="right">
								<div v-for="(value, index) in secondaryList" :key="index" :class="secondaryId == value.id ? 'actived' : ''" @click="secondaryClick(value)">{{ value.title }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div ref="myElement" class="block_3">
				<div class="block_3_main">
					<div class="left"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">Product Filters</div>
						<div class="check_all" @click="clearAll">Clear All</div>
						<div class="filter_box">
							<div class="filter_el">
								<div class="tit">Tested Apps</div>
								<div class="checkbox_box">
									<van-checkbox-group v-model="appsChecked" checked-color="#006BB3" @change="appsChange">
										<div v-for="(value, index) in apps_list" class="checkbox_el">
											<van-checkbox :name="value.id" shape="square">{{ value.title }}</van-checkbox>
										</div>
									</van-checkbox-group>
								</div>
							</div>
							<div class="filter_el">
								<div class="tit">Format</div>
								<div class="checkbox_box">
									<van-checkbox-group v-model="formatChecked" checked-color="#006BB3" @change="formatChange">
										<div v-for="(value, index) in format_list" class="checkbox_el">
											<van-checkbox :name="value.id" shape="square">{{ value.title }}</van-checkbox>
										</div>
									</van-checkbox-group>
								</div>
							</div>
							<div class="filter_el">
								<div class="tit">Host/Source</div>
								<div class="checkbox_box">
									<van-checkbox-group v-model="sourceChecked" checked-color="#006BB3" @change="sourceChange">
										<div v-for="(value, index) in source_list" class="checkbox_el">
											<van-checkbox :name="value.id" shape="square">{{ value.title }}</van-checkbox>
										</div>
									</van-checkbox-group>
								</div>
							</div>
						</div>
					</div>
					<div class="right">
						<div class="top_box_1"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="left_box">
								Products ({{ total }})
								<div class="left_box_el">{{ initArray(initTitle) }}</div>
							</div>
							<div class="right_box" @click="goList">
								<van-badge :content="ids.length" max="99999" color="#E37542">
									<img class="icon" src="../../assets/img/nav/icon_1.webp" />
								</van-badge>
							</div>
						</div>
						<div class="top_box_2"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="left_box">
								<div class="btn_box">
									<van-button color="#006BB3" class="btn_el" @click="addWatchs">Batch Add To List</van-button>
								</div>
							</div>
							<div class="right_box">
								<input v-model="searchVal" placeholder="Search by Name, or Keyword" @keyup.enter="searchClick" />
								<van-icon name="search" class="icon" size="20" color="#006BB3" @click="searchClick" />
							</div>
						</div>
						<div class="table_box"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<el-table
								ref="multipleTableRef"
								:data="tableData"
								stripe
								style="width: 100%" 
								tooltip-effect="dark"
								v-loading="tableLoading"
								empty-text="No matching records found"
								@selection-change="handleSelectionChange"
								@row-click="rowClick"
							><!--height="auto"-->
								<el-table-column type="expand" width="30">
									<template slot-scope="scope">
										<div class="info_box">
											<div class="left_box">
												<div class="tit_box">
													Tested Apps:
													<div style="display: inline-block;" v-if="scope.row.apps_name.length > 0">
														<span v-for="(value, index) in scope.row.apps_name" :key="index">
															{{ index == scope.row.apps_name.length - 1 ? value.title : value.title + ', ' }}
														</span>
													</div>
												</div>
												<div class="tit_box">
													Unit: <span>{{ scope.row.unit || '' }}</span>
												</div>
												<div class="tit_box">
													Host/Source: <span>{{ scope.row.source_name || '' }}</span>
												</div>
												<div class="tit_box">
													Isotype: <span>{{ scope.row.Isotype || '' }}</span>
												</div>
											</div>
											<div class="right_box" @click="goInfo(scope.row)">View Details</div>
										</div>
									</template>
								</el-table-column>
								<el-table-column type="selection" width="45"></el-table-column>
								<el-table-column sortable prop="product_name" label="Name" width="290" show-overflow-tooltip>
									<template slot-scope="scope">
										{{ scope.row.product_name || '' }}
									</template>
								</el-table-column>
								<el-table-column sortable prop="cate_name" label="TYPE" align="center" show-overflow-tooltip>
									<template slot-scope="scope">
										{{ scope.row.cate_name || '' }}
									</template>
								</el-table-column>
								<el-table-column sortable prop="" label="FORMAT" align="center" show-overflow-tooltip>
									<template slot-scope="scope">
										<div v-if="scope.row.format_name.length > 0">
											<span v-for="(value, index) in scope.row.format_name" :key="index">
												{{ index == scope.row.format_name.length - 1 ? value.title : value.title + ', ' }}
											</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column sortable prop="catalog" label="CATALOG" align="center" show-overflow-tooltip>
									<template slot-scope="scope">
										{{ scope.row.catalog || '' }}
									</template>
								</el-table-column>
								<el-table-column  fixed="right" label="" width="60" align="center">
									<template slot-scope="scope">
										<!-- <el-popconfirm
											v-if="scope.row.status == 1"
											class="popconfirm"
											confirm-button-text='Confirm'
											cancel-button-text='Cancel'
											title="Are you sure you want to add it to the list?"
											@confirm="addWatch(scope.row)"
										> -->
											<van-icon v-if="scope.row.status == 1" name="add-o" size="24" style="top: 2px;cursor: pointer;" color="#808080" slot="reference" @click="addWatch(scope.row)" />
										<!-- </el-popconfirm> -->
										<van-icon v-if="scope.row.status == 2" name="passed" size="24" style="top: 2px;" color="#00AB82" />
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="bot_box">
							<div class="left_box">
								Showing {{ (Number(current_page - 1) * pageNum) + 1 }} to {{ last_page != page ? current_page * pageNum : total }} of {{ total }} entries&ensp;
								<el-select v-model="pageNum" placeholder="" style="width: 78px;background-color: transparent;" size="small" @change="pageChange2">
									<el-option :label="25" :value="25"></el-option>
									<el-option :label="50" :value="50"></el-option>
									<el-option :label="100" :value="100"></el-option>
								</el-select>
							</div>
							<div class="right_box">
								<div class="page_box">
									<el-pagination
										:small="false"
										background
										layout="prev, pager, next"
										:total="total"
										:page-size="pageNum"
										:current-page="page"
										@current-change="pageChange"
									>
									</el-pagination>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块3-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import { getProductSelect, getProductList, productGetDiseasesslist, productGetDiseaseslist } from '@/api/public.js'
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			tableData: [],
			current_page: 0,
			last_page: 0,
			pageNum: 25,
			page: 1,
			total: 0,
			multipleSelection: [],
			searchVal: '',
			checkList: [],  //复选框选中值
			cate_list: [],  // type
			cateId: '',  //选中id
			diseases_list: [],  // diseases
			diseasesId: null,  //选中id
			apps_list: [],  // apps
			appsChecked: [],  //选中数组
			format_list: [],  // format
			formatChecked: [],  //选中数组
			source_list: [],  // source
			sourceChecked: [],  //选中数组
			secondaryList: [],  //次要分类
			secondaryId: null,  //选中id
			tableLoading: false,
			idsStr: [],
			ids: [],
			initTitle: []
		}
	},
	created(){
		let that = this;
		//获取购物车数据
		if(JSON.parse(localStorage.getItem('idsStr'))) {
			that.idsStr = JSON.parse(localStorage.getItem('idsStr')).split(',');
		}
		if(JSON.parse(localStorage.getItem('ids'))) {
			that.ids = JSON.parse(localStorage.getItem('ids')).split(',');
		}
		//获取筛选项
		that.getSelectList();
	},
	mounted() {
		let that = this;
		that.isLoading = false;
		that.$nextTick(() => {
			//跳转至指定位置
			if(that.$route.fullPath.includes('?')) {
				let target = document.querySelector('#jumpBox').getBoundingClientRect();
				window.scrollTo({ top: target.top, behavior: 'smooth', });
			}
		});
	},
	methods: {
		//点击批量添加按钮
		addWatchs() {
			let that = this;
			if(that.multipleSelection.length > 0) {
				// that.$confirm('Are you sure you want to add the selected product to my list?', 'Tips', {
				// 	confirmButtonText: 'Confirm',
				// 	cancelButtonText: 'Cancel',
				// 	type: 'warning'
				// }).then(() => {
					that.multipleSelection.forEach((value, index) => {
						if(value.status == 1) {
							that.idsStr.push(value.id + '_1');
							that.ids.push(value.id);
							value.status = 2;
						}
					});
					localStorage.setItem('idsStr', JSON.stringify(that.idsStr.join(',')));
					localStorage.setItem('ids', JSON.stringify(that.ids.join(',')));
					that.$toast('Added successfully');
					that.$refs.multipleTableRef.clearSelection();
					//更新导航购物车数量
					that.$refs.navChild.initCount();
				// }).catch(() => {});
			}else {
				that.$toast('Please select the products to add to your shopping cart first.');
			}
		},
		//点击表格添加按钮
		addWatch(value) {
			let that = this;
			//缓存至购物车
			that.idsStr.push(value.id + '_1');
			that.ids.push(value.id);
			value.status = 2;
			localStorage.setItem('idsStr', JSON.stringify(that.idsStr.join(',')));
			localStorage.setItem('ids', JSON.stringify(that.ids.join(',')));
			that.$toast('Added successfully');
			//更新导航购物车数量
			that.$refs.navChild.initCount();
		},
		//侧边选择
		appsChange() {
			let that = this;
			// console.log(that.appsChecked);
			that.page = 1;
			//获取产品列表
			that.getProduct();
		},
		formatChange() {
			let that = this;
			// console.log(that.formatChecked);
			that.page = 1;
			//获取产品列表
			that.getProduct();
		},
		sourceChange() {
			let that = this;
			// console.log(that.sourceChecked);
			that.page = 1;
			//获取产品列表
			that.getProduct();
		},
		//点击搜索
		searchClick() {
			let that = this;
			// if(that.searchVal) {
				that.pageNum = 25;
				that.page = 1;
				//获取产品列表
				that.getProduct();
			// }else {
			// 	that.$toast('Please enter name, keywords or catalog number to search.');
			// }
		},
		//获取产品列表
		getProduct(type) {
			let that = this;
			that.tableLoading = true;
			getProductList({
				keyword: that.searchVal,
				cate_id: that.cateId ? that.cateId : '',
				diseases_id: that.diseasesId ? that.diseasesId : '',
				diseases_ids: that.secondaryId ? that.secondaryId : '',
				apps_id: that.appsChecked.length > 0 ? that.appsChecked.join(',') : '',
				format: that.formatChecked.length > 0 ? that.formatChecked.join(',') : '',
				source: that.sourceChecked.length > 0 ? that.sourceChecked.join(',') : '',
				page: that.page,
				page_size: that.pageNum,
				ids: that.ids.length > 0 ? that.ids.join(',') : ''
			}).then(res => {
				that.tableData = res.data.data;
				that.total = res.data.total;
				that.current_page = res.data.current_page;
				that.last_page = res.data.last_page;
				that.initTitle = [];
				that.tableLoading = false;
				if(that.cateId) {
					that.cate_list.forEach((value, index) => {
						if(value.id == that.cateId) { that.initTitle.push(value.title); }
					});
				}
				if(that.diseasesId) {
					that.diseases_list.forEach((value, index) => {
						if(value.id == that.diseasesId) { that.initTitle.push(value.title); }
					});
				}
				if(that.secondaryId) {
					that.secondaryList.forEach((value, index) => {
						if(value.id == that.secondaryId) { that.initTitle.push(value.title); }
					});
				}
				if(type) {
					//滚动到列表顶部
					that.$refs.myElement.scrollIntoView({ behavior: 'smooth' });
				}
				// console.log(JSON.parse(JSON.stringify(that.tableData[0])));
			});
		},
		//清空筛选项
		clearAll() {
			let that = this;
			that.appsChecked = [];
			that.formatChecked = [];
			that.sourceChecked = [];
			that.page = 1;
			that.getProduct();
		},
		//产品分类点击
		cateClick(value) {
			let that = this;
			if(that.cateId == value.id) {
				that.cateId = '';
				that.diseasesId = null;
				that.diseases_list = [];
				that.secondaryList = [];
				that.secondaryId = null;
				that.page = 1;
				that.getProduct();
			}else {
				that.cateId = value.id;
				//请求疾病二级列表  value.children
				productGetDiseaseslist({ cate_id: value.id }).then(res => {
					that.diseases_list = res.data;
					that.diseasesId = null;
					that.secondaryList = [];
					that.secondaryId = null;
					that.page = 1;
					that.getProduct();
				});
			}
			
			// if(that.cateId == value.id) {
			// 	that.cateId = null;
			// }else {
			// 	that.cateId = value.id;
			// }
			// that.page = 1;
			// that.getProduct();
		},
		//Diseases点击
		diseasesClick(value) {
			let that = this;
			if(that.diseasesId == value.id) {
				that.diseasesId = null;
				that.secondaryList = [];
				that.secondaryId = null;
				that.page = 1;
				that.getProduct();
			}else {
				that.diseasesId = value.id;
				//请求疾病列表  value.children
				productGetDiseasesslist({
					cate_id: that.cateId,
					diseases_id: value.id
				}).then(res => {
					that.secondaryList = res.data;
					that.secondaryId = null;
					that.page = 1;
					that.getProduct();
				});
			}
		},
		//secondary点击
		secondaryClick(value) {
			let that = this;
			if(that.secondaryId == value.id) {
				that.secondaryId = null;
			}else {
				that.secondaryId = value.id;
			}
			that.page = 1;
			that.getProduct();
		},
		//获取筛选项
		getSelectList() {
			let that = this;
			//赋值
			if(that.$route.query.type) {
				that.cateId = that.$route.query.type;
			}
			getProductSelect({
				cate_id: that.cateId,
				diseases_id: '',
				apps_id: '',
				format: '',
				source: ''
			}).then(res => {
				that.cate_list = res.data.cate_list;
				// that.diseases_list = res.data.diseases_list;
				that.apps_list = res.data.apps_list;
				that.format_list = res.data.format_list;
				that.source_list = res.data.source_list;
				//赋值
				if(that.cateId) {
					that.cate_list.forEach((value, index) => {
						if(value.id == that.cateId) {
							//请求疾病分类二级列表
							productGetDiseaseslist({ cate_id: value.id }).then(res2 => {
								that.diseases_list = res2.data;
								that.diseasesId = null;
								that.secondaryList = [];
								that.secondaryId = null;
							});
						}
					});
				}
				if(that.$route.query.disease) {
					that.diseasesId = that.$route.query.disease;
					that.diseases_list.forEach((value, index) => {
						if(value.id == that.diseasesId) {
							//请求疾病列表  value.children
							productGetDiseasesslist({
								cate_id: that.cateId,
								diseases_id: value.id
							}).then(res2 => {
								that.secondaryList = res2.data;
								that.secondaryId = null;
							});
						}
					});
				}
				if(that.$route.query.tests) {
					that.appsChecked.push(Number(that.$route.query.tests));
				}
				if(that.$route.query.search) {
					that.searchVal = that.$route.query.search;
				}
				//获取产品列表
				that.getProduct();
			});
		},
		//表格多选
		handleSelectionChange(val) {
			let that = this;
			that.multipleSelection = val;
		},
		//分页点击
		pageChange(val) {
			let that = this;
			that.page = val;
			that.getProduct(true);
		},
		//分页条数选择
		pageChange2(val) {
			let that = this;
			that.pageNum = val;
			that.getProduct();
		},
		//跳转产品详情
		goInfo(value) {
			let that = this;
			if(value.custom) {
				let routeData = that.$router.resolve({name: "ProductInfo", params: { productId: value.custom } });
				window.open(routeData.href, '_blank');
			}else {
				that.$toast('Product parameter exception, failed to obtain details.');
			}
		},
		//跳转清单列表
		goList() {
			this.$router.push('/watch-list');
		},
		//跳转联系我们
		goContact() {
			this.$router.push('/contact');
		},
		//表格行点击
		rowClick(row, column, event) {
			let that = this;
			if(column.label) {
				that.$refs.multipleTableRef.toggleRowExpansion(row);
			}
		},
		goIm() {
			window.open('https://i-membrane.com/');
		},
		goHome() {
			this.$router.push('/');
		},
		initArray(value) {
			return value.join(' / ');
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #000000;
	//块3
	.block_3{
		padding: 64px 0 100px 0;
		.block_3_main{
			width: 1140px;
			margin: 0 auto;
			display: flex;
			align-items: start;
			.right{
				flex: 1;
				padding-left: 36px;
				.table_box{
					padding-top: 10px;
					.info_box{
						display: flex;
						align-items: center;
						padding: 10px 20px 10px 85px;
						.right_box{
							width: auto;
							font-size: 16px;
							color: #006BB3;
							cursor: pointer;
							user-select: none;
						}
						.left_box{
							flex: 1;
							.tit_box{
								padding: 2px 0;
								font-size: 16px;
								font-weight: bold;
								color: #000000;
								span{
									font-size: 16px;
									font-weight: normal;
									color: #666666;
								}
							}
						}
					}
				}
				.bot_box{
					display: flex;
					align-items: center;
					margin-top: 10px;
					padding: 16px 5px 16px 20px;
					background-color: #F6F6F6;
					.right_box{
						width: auto;
					}
					.left_box{
						flex: 1;
						color: #808080;
						font-size: 16px;
					}
				}
				.top_box_2{
					display: flex;
					align-items: center;
					padding-top: 18px;
					.right_box{
						width: auto;
						position: relative;
						.icon{
							position: absolute;
							top: 6px;
							right: 10px;
							cursor: pointer;
						}
						input{
							width: 255px;
							height: 35px;
							padding: 2px 36px 0 12px;
							line-height: 35px;
							border: 1px solid #808080;
							color: #006BB3;
							text-align: center;
							border-radius: 6px;
						}
					}
					.left_box{
						flex: 1;
						.btn_box{
							.btn_el{
								padding: 6px 10px 2 10px;
								font-size: 18px;
								border-radius: 6px;
							}
						}
					}
				}
				.top_box_1{
					display: flex;
					align-items: center;
					.right_box{
						width: auto;
						img{
							width: 48px;
							cursor: pointer;
							user-select: none;
						}
					}
					.left_box{
						flex: 1;
						font-size: 36px;
						.left_box_el{
							padding-top: 0px;
							font-size: 24px;
						}
					}
				}
			}
			.left{
				width: 200px;
				padding: 30px 15px;
				background-color: #F6F6F6;
				.filter_box{
					.filter_el:last-child{
						border-bottom: none;
					}
					.filter_el{
						padding: 5px 0 8px 0;
						border-bottom: 1px solid #CCCCCC;
						.checkbox_box{
							.checkbox_el{
								margin: 10px 0;
								font-size: 16px;
							}
						}
						.tit{
							padding-top: 5px;
							font-size: 18px;
						}
					}
				}
				.check_all{
					padding-top: 20px;
					font-size: 18px;
					color: #006BB3;
					cursor: pointer;
					user-select: none;
				}
				.title{
					font-size: 18px;
					color: #808080;
				}
			}
		}
	}
	//块2
	.block_2{
		.block_2_main{
			width: 1140px;
			margin: 0 auto;
			padding-top: 44px;
			.list_box{
				.list_el{
					display: flex;
					padding: 8px 0;
					.right{
						flex: 1;
						div.actived{
							color: #E37542;
							border: 1px solid #E37542;
							background-color: #FFF9F6;
						}
						div{
							display: inline-block;
							margin: 8px;
							padding: 8px 16px 5px 16px;
							border: 1px solid #CCCCCC;
							border-radius: 26px;
							cursor: pointer;
							user-select: none;
							font-size: 18px;
						}
					}
					.left{
						width: 170px;
						position: relative;
						top: 16px;
						font-size: 18px;
						color: #808080;
					}
				}
			}
		}
		.top_box{
			width: 100%;
			margin: 0 auto;
			max-width: 1920px;
			padding: 30px 0 24px 0;
			background-color: #006BB3;
			div{
				width: 1140px;
				margin: 0 auto;
				font-size: 30px;
				color: #ffffff;
			}
		}
	}
	//块1
	.block_1{
		padding: 50px 0 60px 0;
		.block_1_main{
			width: 1140px;
			margin: 0 auto;
			.txt{
				margin-top: 30px;
				padding: 20px 30px 14px 30px;
				background-color: #F6F6F6;
				font-size: 18px;
				span{
					font-size: 18px;
					color: #0096E3;
					text-decoration: underline;
					cursor: pointer;
					user-select: none;
				}
			}
			.text{
				font-size: 18px;
			}
			.title{
				padding: 6px 0;
				font-size: 48px;
				font-weight: bold;
				color: #006BB3;
			}
			.tit{
				font-size: 30px;
			}
		}
	}
	//位置块
	.location_box{
		width: 1140px;
		margin: 0 auto;
		padding-top: 30px;
		.icon{
			top: 4px;
		}
		span{
			display: inline-block;
			padding: 0 5px;
			font-size: 16px;
		}
	}
}
</style>
<style scoped>
/*分页*/
>>> .page_box .el-pager li:hover{
	color: #E37542 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #E37542 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
	color: #ffffff !important;
}
>>> .table_box .el-table__header tr th{
	background-color: #003B63;
}
>>> .table_box .el-table__header tr th .cell{
	color: #ffffff;
}
>>> .table_box .el-table .el-table__cell{
	padding: 8px 0;
}
>>> .table_box .el-table__header tr th .sort-caret.ascending{
	border-bottom-color: #ffffff;
}
>>> .table_box .el-table__header tr th .sort-caret.descending{
	border-top-color: #ffffff;
}
>>> .table_box .el-table .descending .sort-caret.descending{
	border-top-color: #E37542;
}
>>> .table_box .el-table .ascending .sort-caret.ascending{
	border-bottom-color: #E37542;
}
>>> .el-table th.el-table__cell>.cell{
	padding-left: 14px;
}
>>> .table_box .el-checkbox__input.is-checked .el-checkbox__inner, >>> .table_box .el-checkbox__input.is-indeterminate .el-checkbox__inner{
	background-color: rgb(0, 107, 179);
	border-color: rgb(0, 107, 179);
}
>>> .table_box .cell{
	font-size: 16px;
	color: #000000;
}
>>> .table_box .el-table__expand-icon>.el-icon{
	top: 35%;
}
</style>